import { ProtectedPage } from "@components/ProtectedPage";
import { LoginPage } from "@pages/Auth/Login";
import { ResetPassword } from "@pages/Auth/ResetPassword";
import Contract from "@pages/Contract";
import Activities from "@pages/Contract/Activities";
import CalculateResult from "@pages/Contract/CalculateResult";
import InformationCompany from "@pages/Contract/InformationCompany";
import { InsuranceHistory } from "@pages/Contract/InsuranceHistory";
import Dashboard from "@pages/Dashboard";
import ListQuotes from "@pages/ListQuotes";
import ManagementUsers from "@pages/ManagementUsers";
import InformationDetail from "@pages/ManagementUsers/InformationDetail";
import ListUsers from "@pages/ManagementUsers/ListUsers";
import PageNotFound from "@pages/PageNotFound";
import SearchCompany from "@pages/SearchCompany";
import SelectType from "@pages/SelectType";
import { Layout } from "layout";
import type { RouteObject } from "react-router-dom";

export const protectedRoutes: RouteObject[] = [
  {
    path: "/",
    element: (
      <ProtectedPage>
        <Layout />
      </ProtectedPage>
    ),
    children: [
      {
        element: <Dashboard />,
        index: true,
      },
      {
        path: "/search-company",
        element: <SearchCompany />,
      },
      {
        path: "/select-type",
        element: <SelectType />,
      },
      {
        path: "/contract",
        element: <Contract />,
        children: [
          {
            path: "activities",
            element: <Activities />,
          },
          {
            element: <InformationCompany />,
            index: true,
          },
          {
            path: "calculate-result",
            element: <CalculateResult />,
          },
          {
            path: "insurance-history",
            element: <InsuranceHistory />,
          },
        ],
      },
      {
        path: "/liste-des-devis",
        element: <ListQuotes />,
      },
      {
        path: "/management-users",
        element: <ManagementUsers />,
        children: [
          {
            index: true,
            element: <ListUsers />,
          },
          {
            path: "information-detail",
            element: <InformationDetail />,
          },
        ],
      },
    ],
  },
  {
    path: "/login",
    element: <LoginPage />,
  },
  {
    path: "/auth/reset-password",
    element: <ResetPassword />,
  },
  {
    path: "*",
    element: <PageNotFound />,
  },
];

export const authRoutes: RouteObject[] = [
  {
    path: "/login",
    element: <LoginPage />,
  },
  {
    path: "/auth/reset-password",
    element: <ResetPassword />,
  },
  {
    path: "*",
    element: <PageNotFound />,
  },
];
